module.exports = __webpack_public_path__ + "static/media/boyBands.bb05722f.jpg";